import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles({
  icon: {
    width: '1.5rem',
    height: '1.5rem',
    fillOpacity: '0.87',
  },
});

const SearchIcon = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 24 24" className={styles.icon} fill="white">
      <path
        d="M11.4346 10.0629H10.7119L10.4558 9.81589C11.3523 8.77301 11.8921 7.4191 11.8921 5.94625C11.8921 2.66209 9.22996 0 5.9458 0C2.66163 0 -0.000457764 2.66209 -0.000457764 5.94625C-0.000457764 9.23042 2.66163 11.8925 5.9458 11.8925C7.41864 11.8925 8.77255 11.3528 9.81543 10.4563L10.0624 10.7124V11.4351L14.6365 16L15.9995 14.6369L11.4346 10.0629ZM5.9458 10.0629C3.66792 10.0629 1.82916 8.22413 1.82916 5.94625C1.82916 3.66838 3.66792 1.82962 5.9458 1.82962C8.22367 1.82962 10.0624 3.66838 10.0624 5.94625C10.0624 8.22413 8.22367 10.0629 5.9458 10.0629Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </SvgIcon>
  );
};

export default memo(SearchIcon);
